import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import { useNavigate } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function Quotes() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [ShowFilters, SetShowFilters] = useState(true);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({});
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);
  const navigate = useNavigate();
  const ShowHideFilters = () => {
    SetShowFilters(!ShowFilters);
  };

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteGetCompleteDataSetForForeignKeysV2",
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          l_oResponse[0] = [] as any;
          l_oResponse[0].push({ PID: 1, Name: "Driver" });
          l_oResponse[0].push({ PID: 2, Name: "Helper" });
          l_oResponse[0].push({ PID: 3, Name: "Both" });
          setScreenListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  const [customData, setCustomdata] = useState({
    JobID: "",
    ClientName: "",
    CompanyName: "",
    mnvquoteStatusID: 0,
    FromPostcode: "",
    ToPostcode: "",
    MobileNumber: "",
  });

  function getScreenData(dataOverride?: typeof customData) {
    const data = dataOverride ?? customData;

    let object = {
      jobID: data.JobID,
      clientName: data.ClientName,
      companyName: data.CompanyName,
      mnvquoteStatusID: data.mnvquoteStatusID,
      fromPostcode: data.FromPostcode,
      toPostcode: data.ToPostcode,
      mobileNumber: data.MobileNumber,
    };

    setIsAnimation(true);
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteGetCompleteGridDataCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false,
          );

          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function AddNew() {
    let object = {
      jobID: 0,
      // clientName: "",
      // companyName: "",
      // mnvquoteStatusID: 0,
      // fromPostcode: "",
      // toPostcode: "",
    };

    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/AddNew", object)
      .then((response) => {
        setIsAnimation(false);

        const newID = Number(response.data);
        if (newID && newID > 0) {
          navigate(`/quote_detail/${newID}`);
        } else {
          if (response.data.Status === 1) {
            let l_response = response.data.Data;
            const idFromData =
              l_response &&
              l_response[0] &&
              (l_response[0].MNVQuoteID || l_response[0].ID);

            if (idFromData) {
              navigate(`/quote_detail/${idFromData}`);
            } else {
              showErrorMessage("New Quote ID not found in response");
            }
          } else {
            showErrorMessage(response.data.Message || "Failed to create quote");
          }
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.MNVQuoteID || addEditObject.MNVQuoteID == 0) {
      showErrorMessage("Please select Mover Type");
      IsOkay = false;
    } else if (!addEditObject.MNVBaseID || addEditObject.MNVBaseID == 0) {
      showErrorMessage("Please select Base");
      IsOkay = false;
    } else if (!addEditObject.SiteUserID || addEditObject.SiteUserID == "") {
      showErrorMessage("Please select Site User");
      IsOkay = false;
    } else if (
      !addEditObject.EmailAddress ||
      addEditObject.EmailAddress == ""
    ) {
      showErrorMessage("Please enter Email");
      IsOkay = false;
    } else if (!addEditObject.MobileNo || addEditObject.MobileNo == "") {
      showErrorMessage("Please enter Phone No");
      IsOkay = false;
    }
    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVQuoteID = addEditObject.MNVQuoteID;
    object.MNVBaseID = addEditObject.MNVBaseID;
    object.SiteUserID = addEditObject.SiteUserID;
    object.Name = addEditObject.Name;
    object.CNICNo = addEditObject.CNICNo;
    object.EmailAddress = addEditObject.EmailAddress;
    object.MobileNo = addEditObject.MobileNo;
    object.AddressLine1 = addEditObject.AddressLine1;
    object.AddressLine2 = "";
    object.IsActive = addEditObject.IsActive;
    object.IsContractor = addEditObject.IsContractor;
    object.VAT = addEditObject.VAT;
    object.CompanyCommission = addEditObject.CompanyCommission;
    object.Rating = addEditObject.Rating;
    object.CreatedByID = 0;
    object.LastUpdatedByID = 0;
    object.IsDeleted = false;
    object.Insurance = addEditObject.InsuranceExpiryDate;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVMover/MNVMoverSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;

          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVQuoteID = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteDeleteRecord",
        object,
      )
      .then((response) => {
        let l_response = response.data;
        getScreenData();

        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteUserData(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.JobID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/MNVDeleteUserData", object)
      .then((response) => {
        let l_response = response.data;
        getScreenData();
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
      globalState.setConfirmationModalObject({
        ShowPopup: false,
        Heading: "",
        Message: "",
        ID: 0,
        SelectedID: 0,
        OtherID: 0,
      });
    } else if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        globalState.setConfirmationModalObject({
          ShowPopup: true,
          Heading: "Are you sure?",
          Message:
            "The client information will be deleted, do you want to proceed?",
          ID: 3,
          SelectedID: obj.SelectedID,
          OtherID: 0,
        });
      } else {
        globalState.setConfirmationModalObject({
          ShowPopup: false,
          Heading: "",
          Message: "",
          ID: 0,
          SelectedID: 0,
          OtherID: 0,
        });
      }
    } else if (obj.ID === 3) {
      if (obj.isConfirm === true) {
        deleteUserData(obj.SelectedID);
      }
      globalState.setConfirmationModalObject({
        ShowPopup: false,
        Heading: "",
        Message: "",
        ID: 0,
        SelectedID: 0,
        OtherID: 0,
      });
    }
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  function clearFilters2() {
    const clearedData = {
      JobID: "",
      ClientName: "",
      CompanyName: "",
      mnvquoteStatusID: 0,
      FromPostcode: "",
      ToPostcode: "",
      MobileNumber: "",
    };

    setCustomdata(clearedData);
    getScreenData(clearedData);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "JobID")) {
        (
          document.getElementById("imgSort" + "JobID") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVVanTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVVanTypeName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverTypeName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "BusinessName")) {
        (
          document.getElementById(
            "imgSort" + "BusinessName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }

      if (document.getElementById("imgSort" + "MNVClientName")) {
        (
          document.getElementById(
            "imgSort" + "MNVClientName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "MNVQuoteStatusName")) {
        (
          document.getElementById(
            "imgSort" + "MNVQuoteStatusName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "TransactionId")) {
        (
          document.getElementById(
            "imgSort" + "TransactionId",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "CreationTimestamp")) {
        (
          document.getElementById(
            "imgSort" + "CreationTimestamp",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "RequestedDate")) {
        (
          document.getElementById(
            "imgSort" + "RequestedDate",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "RequiredVanTime")) {
        (
          document.getElementById(
            "imgSort" + "RequiredVanTime",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "FromPostalCode")) {
        (
          document.getElementById(
            "imgSort" + "FromPostalCode",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "FromCity")) {
        (
          document.getElementById("imgSort" + "FromCity") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "ToPostalCode")) {
        (
          document.getElementById(
            "imgSort" + "ToPostalCode",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "ToCity")) {
        (
          document.getElementById("imgSort" + "ToCity") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "PayableAmount")) {
        (
          document.getElementById(
            "imgSort" + "PayableAmount",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSort" + "OTP")) {
        (
          document.getElementById("imgSort" + "OTP") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");
  useEffect(() => {
    if (SelectedMobileNumber != "+44-") {
      setAddEditObject((prevState: any) => ({
        ...prevState,
        MobileNo: SelectedMobileNumber,
      }));
    }
  }, [SelectedMobileNumber]);

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div
            className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer"
            onClick={ShowHideFilters}
          >
            Filters
            <img
              className={` ${ShowFilters ? "rotate-180" : ""}`}
              src="images/chev-down.svg"
              width={16}
              height={16}
            />
          </div>
          {ShowFilters && (
            <div className="inline-block-d text-center width-100 reuse-border p-all20">
              <>
                <div className="grid-d fr-1111 gap-20 sm-grid-cols">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Job ID:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Job ID"
                      value={customData.JobID}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          JobID: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Company Name:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Company Name"
                      value={customData.CompanyName}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          CompanyName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Client Name:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Client Name"
                      value={customData.ClientName}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          ClientName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Status:
                    </span>
                    <select
                      className="input-field w-100"
                      value={customData.mnvquoteStatusID}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          mnvquoteStatusID: Number(e.target.value),
                        }))
                      }
                    >
                      <option value={0}>All</option>
                      {screenListData[4] &&
                        screenListData[4].map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            <React.Fragment key={index}>
                              <option value={item.PID}>{item.Name}</option>
                            </React.Fragment>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      From Postcode:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="From Postcode"
                      value={customData.FromPostcode}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          FromPostcode: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      To Postcode:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="To Postcode"
                      value={customData.ToPostcode}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          ToPostcode: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Mobile Number:
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Mobile Number"
                      value={customData.MobileNumber}
                      onChange={(e) =>
                        setCustomdata((prev) => ({
                          ...prev,
                          MobileNumber: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="flex-daj btn-start flex-gap10 mt-20">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => getScreenData()}
                  >
                    Apply Filter
                  </a>
                  <a className="btn-primary flex-daj" onClick={clearFilters2}>
                    Clear Filter
                  </a>
                </div>
              </>
            </div>
          )}

          <div className="flex-d justify-btw mt-20 mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  // onClick={AddNew}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    AddNew();
                  }}
                  // onClick={() => {
                  //   setAddEditObject({});
                  //   setIsAddNew(1);
                  // }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblquote", "Quote")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div
            className={` ${ShowFilters ? "flow-auto-lg32" : "flow-auto-lg4"}`}
          >
            <table className="reuse-table" id="tblquote">
              <thead>
                <tr>
                  <th>Action</th>
                  <th className="reuse-tdxs">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Job ID
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "JobID")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("JobID")}
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "JobID"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdxs">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Van Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVVanTypeName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MNVVanTypeName")}
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "MNVVanTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Mover Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVMoverTypeName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MNVMoverTypeName")
                          }
                          title={"Sort By User"}
                        >
                          <span id={"imgSort" + "MNVMoverTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Move Manager
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MoverManager")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MoverManager")}
                          title={"Sort By Mover Manager"}
                        >
                          <span id={"imgSort" + "MoverManager"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Follow UP
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "FollowUP")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("FollowUP")}
                          title={"Sort By Follow UP"}
                        >
                          <span id={"imgSort" + "FollowUP"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdsm2">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Mobile Number
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MobileNumber")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MobileNumber")}
                          title={"Sort By Mobile Number"}
                        >
                          <span id={"imgSort" + "MobileNumber"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Company
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "BusinessName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("BusinessName")}
                          title={"Sort By Business Name"}
                        >
                          <span id={"imgSort" + "BusinessName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdsm2">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Client
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVClientName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MNVClientName")}
                          title={"Sort By Client"}
                        >
                          <span id={"imgSort" + "MNVClientName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Status
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVQuoteStatusName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MNVQuoteStatusName")
                          }
                          title={"Sort By Status"}
                        >
                          <span id={"imgSort" + "MNVQuoteStatusName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdxs">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Gen
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "TransactionId")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("TransactionId")}
                          title={"Sort By Gen"}
                        >
                          <span id={"imgSort" + "TransactionId"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Creation Date
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(
                              e,
                              "CreationTimestamp(Date-View)",
                            )
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("CreationTimestamp")
                          }
                          title={"Sort By Creation Date"}
                        >
                          <span id={"imgSort" + "CreationTimestamp"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Date
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "RequestedDate(Date-View)")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("RequestedDate")}
                          title={"Sort By Date"}
                        >
                          <span id={"imgSort" + "RequestedDate"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdxs">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Hrs
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(
                              e,
                              "RequiredVanTime(Number-View)",
                            )
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("RequiredVanTime")
                          }
                          title={"Sort By Hrs"}
                        >
                          <span id={"imgSort" + "RequiredVanTime"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        From
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "FromPostalCode")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("FromPostalCode")}
                          title={"Sort By From"}
                        >
                          <span id={"imgSort" + "FromPostalCode"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    {" "}
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        From City
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "FromCity")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("FromCity")}
                          title={"Sort By From City"}
                        >
                          <span id={"imgSort" + "FromCity"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        To
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "ToPostalCode")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("ToPostalCode")}
                          title={"Sort By To"}
                        >
                          <span id={"imgSort" + "ToPostalCode"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        To City
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "ToCity")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("ToCity")}
                          title={"Sort By To City"}
                        >
                          <span id={"imgSort" + "ToCity"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdxs">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Amount
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "PayableAmount")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("PayableAmount")}
                          title={"Sort By Amount"}
                        >
                          <span id={"imgSort" + "PayableAmount"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdxs">
                    {" "}
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        OTP
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "OTP")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("OTP")}
                          title={"Sort By OTP"}
                        >
                          <span id={"imgSort" + "OTP"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Are you sure?",
                                    Message:
                                      "Are you sure you want to delete data?",
                                    ID: 2,
                                    SelectedID: item.JobID,
                                    OtherID: 0,
                                  })
                                }
                                title="Click here to delete user data for 'right to be forgotten' "
                                // href={"/moverrates?ID=" + item.MNVQuoteID}
                                target="_blank"
                              >
                                <img
                                  src="images/r-cross.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVQuoteID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                              <a
                                href={
                                  item?.MNVQuoteID
                                    ? `/quote_detail/${item.MNVQuoteID}`
                                    : "#"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                  if (!item?.MNVQuoteID) {
                                    e.preventDefault();
                                    return;
                                  }
                                  // e.preventDefault();
                                  // setIsAddNew(2);
                                  // SetSelectedMobileNumber(item.MobileNo);
                                  // setAddEditObject(item);
                                  // setAddEditObject((prevState: any) => ({
                                  //   ...prevState,
                                  //   MobileNo: item.MobileNo,
                                  // }));

                                  // window.open(`/quote_detail/${item.MNVQuoteID}`, "_blank");
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                            </div>
                          </td>
                          <td className="reuse-tdxs">{item.JobID}</td>
                          <td className="reuse-tdxs">{item.MNVVanTypeName}</td>
                          <td>{item.MNVMoverTypeName}</td>
                          <td>{item.MoverManager}</td>
                          <td>{item.FollowUP}</td>
                          <td>{item.MobileNumber}</td>
                          <td>{item.BusinessName}</td>
                          <td>{item.MNVClientName}</td>
                          <td>{item.MNVQuoteStatusName}</td>
                          <td className="reuse-tdxs">{item.TransactionId}</td>
                          <td>{formateDate(item.CreationTimestamp)}</td>
                          <td>{formateDate(item.RequestedDate)}</td>
                          <td className="reuse-tdxs text-right">
                            {item.RequiredVanTime}
                          </td>
                          <td>{item.FromPostalCode}</td>
                          <td>{item.FromCity}</td>
                          <td>{item.ToPostalCode}</td>
                          <td>{item.ToCity}</td>
                          <td className="reuse-tdxs text-right">
                            £
                            {item.PayableAmount?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td className="reuse-tdxs text-right">{item.OTP}</td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Mover Type:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVQuoteID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVQuoteID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Mover</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Base:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVBaseID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVBaseID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Base</option>
                  {screenListData[2] &&
                    screenListData[2].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Site User:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.SiteUserID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SiteUserID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select User</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Date:</span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={
                    addEditObject.InsuranceExpiryDate
                      ? moment(addEditObject.InsuranceExpiryDate).format(
                          "YYYY-MM-DD",
                        )
                      : ""
                  }
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      InsuranceExpiryDate: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Email:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.EmailAddress}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      EmailAddress: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Mobile #:</span>

                <MobileInput
                  SelectedMobileNumber={SelectedMobileNumber}
                  SetSelectedMobileNumber={SetSelectedMobileNumber}
                />

                {/* <input
                  className="input-field w-100"
                  value={addEditObject.MobileNo}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MobileNo: e.target.value,
                    }))
                  }
                /> */}
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Address:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.AddressLine1}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      AddressLine1: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Order By:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Rating}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Rating: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Contractor:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsContractor}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsContractor: e.target.checked ? 1 : 0,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Quotes;
